import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import useWindowSize from '@Hooks/useWindowSize';

const PANEL_ID = 'poster-editor-fancy-text-effect-panel';

export default function PosterEditorFancyTextEffectModal(): ReactElement<any> {
  const {windowHeight} = useWindowSize();
  const height = `${windowHeight / 2}px`;
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_FANCY_TEXT_EFFECT_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
      doesBottomSheetHaveSnapPoints
    >
      <LazyPanel
        panelDirectoryName="poster-editor-fancy-text-effect-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorFancyTextEffectModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_FANCY_TEXT_EFFECT_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
